<template>
  <div
    :class="`
    p-1 px-2
    d-${block ? '' : 'inline-'}block
    bg-${variant} 
    rounded${pill ? '-xl' : ''}
    text-${textColor}
    `"
  >
    <!-- -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "NurseryFeBadge",

  props: {
    variant: {
      type: String,
      default: "light-primary",
    },
    pill: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  computed: {
    textColor() {
      const bgVariant = this.variant;

      if (bgVariant.includes("light-")) {
        return bgVariant.replace("light-", "");
      } else return "white";
    },
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/base/component/badge.vue